import { render, staticRenderFns } from "./SideNavHelp.vue?vue&type=template&id=5d4b50e6&"
import script from "./SideNavHelp.vue?vue&type=script&lang=js&"
export * from "./SideNavHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports